import { render, staticRenderFns } from "./InvestorEventsProjectView.vue?vue&type=template&id=022938be&scoped=true"
import script from "./InvestorEventsProjectView.vue?vue&type=script&lang=js"
export * from "./InvestorEventsProjectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022938be",
  null
  
)

export default component.exports